import React from 'react'
// components
import SkeftoLoader from 'components/UI/Loader/SkeftoLoader'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
import AuthCompanySelectModal from 'components/Modals/AuthCompanySelectModal'
// views
import { SsoLoadingText, SsoLoadingWrapper } from '../views'

type Props = {
  onUsePassword: () => void
}

/** Shown in place of the form while the automatic SSO attempt resolves. */
const SsoLoading: React.FC<Props> = ({ onUsePassword }) => (
  <>
    <SsoLoadingWrapper>
      <SkeftoLoader />
      <SsoLoadingText>Logging you in with Single Sign-On</SsoLoadingText>
      <span />
      <Button type='button' layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={onUsePassword}>
        Login via password
      </Button>
    </SsoLoadingWrapper>
    {/* Kept mounted: silent SSO may still need the company picker. */}
    <AuthCompanySelectModal />
  </>
)

export default SsoLoading
